import * as React from "react";
import type { SVGProps } from "react";

const SvgWeightLoss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={200}
    height={200}
    viewBox="0 0 200 200"
    {...props}
  >
    <g clipPath="url(#clip0_2003_124)">
      <path
        d="M50 68.75C50 55.4892 55.2678 42.7715 64.6447 33.3947C74.0215 24.0178 86.7392 18.75 100 18.75C113.261 18.75 125.979 24.0178 135.355 33.3947C144.732 42.7715 150 55.4892 150 68.75C150 82.0108 144.732 94.7285 135.355 104.105C125.979 113.482 113.261 118.75 100 118.75C86.7392 118.75 74.0215 113.482 64.6447 104.105C55.2678 94.7285 50 82.0108 50 68.75ZM168.75 68.75C168.75 59.9219 167.07 51.4844 164.062 43.75H175C178.438 43.75 181.25 46.5625 181.25 50V175C181.25 178.438 178.438 181.25 175 181.25H25C21.5625 181.25 18.75 178.438 18.75 175V50C18.75 46.5625 21.5625 43.75 25 43.75H35.9375C32.9297 51.4844 31.25 59.9219 31.25 68.75C31.25 106.719 62.0312 137.5 100 137.5C137.969 137.5 168.75 106.719 168.75 68.75ZM153.047 25C140.43 9.72656 121.367 0 100 0C78.6328 0 59.5703 9.72656 46.9531 25H25C11.2109 25 0 36.2109 0 50V175C0 188.789 11.2109 200 25 200H175C188.789 200 200 188.789 200 175V50C200 36.2109 188.789 25 175 25H153.047ZM115.625 87.5C115.625 83.3594 114.023 79.6094 111.367 76.7969L124.492 46.2109C125.859 43.0469 124.375 39.375 121.211 38.0078C118.047 36.6406 114.375 38.125 113.008 41.2891L99.8828 71.875C91.2891 71.9141 84.375 78.9062 84.375 87.5C84.375 96.1328 91.3672 103.125 100 103.125C108.633 103.125 115.625 96.1328 115.625 87.5Z"
        fill="#142745"
      />
    </g>
    <defs>
      <clipPath id="clip0_2003_124">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWeightLoss;
